import type { ActiveTabId } from 'utils/chat-sidebar-layout-storage';

function normalizePath(pathname: string): string {
  const noQuery = pathname.split('?')[0] ?? pathname;
  return noQuery.replace(/\/$/, '') || '/';
}

/** טאב לפי נתיב בלבד — כשאין `view` ב-query */
export function deriveActiveTabIdFromPathname(pathname: string): ActiveTabId | null {
  if (!pathname.startsWith('/chats')) return null;
  if (pathname.startsWith('/chats/custom/')) {
    const m = pathname.match(/^\/chats\/custom\/([^/]+)/);
    if (m) return `custom:${m[1]}` as ActiveTabId;
    return null;
  }
  if (pathname.startsWith('/chats/my')) return 'mine';
  if (pathname.startsWith('/chats/not-my')) return 'team';
  if (
    pathname.startsWith('/chats/bots') ||
    pathname.startsWith('/chats/unassigned') ||
    pathname.startsWith('/chats/completed')
  ) {
    return 'all';
  }
  if (pathname === '/chats' || pathname === '/chats/') return 'all';
  const p = normalizePath(pathname);
  if (p === '/chats' || (p.startsWith('/chats/') && !p.startsWith('/chats/my') && !p.startsWith('/chats/not-my'))) {
    if (
      !p.startsWith('/chats/unassigned') &&
      !p.startsWith('/chats/completed') &&
      !p.startsWith('/chats/bots') &&
      !p.startsWith('/chats/custom')
    ) {
      return 'all';
    }
  }
  return null;
}

export function parseViewQueryParam(search: string): ActiveTabId | null {
  const q = search.startsWith('?') ? search.slice(1) : search;
  const sp = new URLSearchParams(q);
  const v = sp.get('view');
  if (v === 'mine' || v === 'team' || v === 'all') return v;
  if (v?.startsWith('custom:')) return v as ActiveTabId;
  return null;
}

/**
 * מקור אמת לטאב: קודם `view` ב-query, אחר כך נתיב.
 * מחוץ ל-/chats — fallback (למשל מ-localStorage).
 */
export function deriveActiveTabIdFromUrl(
  pathname: string,
  search: string,
  fallbackWhenNotChat: ActiveTabId,
): ActiveTabId {
  if (!pathname.startsWith('/chats')) return fallbackWhenNotChat;
  const fromQuery = parseViewQueryParam(search);
  if (fromQuery) return fromQuery;
  return deriveActiveTabIdFromPathname(pathname) ?? 'mine';
}
